// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"63210e7f","513":"fe337373"}[chunkId] + ".chunk.js";
};